export default __webpack_public_path__ + "d4eb0e70bf56c63d97d9027a833d172e.png";